import React from 'react'
import './GulKaari.css';

const CircleImpact = ({chartData}) => {
    return (
      <div className='circle'>
        <div className='x-box'>
          <div className='x-box-cont'>
            {/* <h1>Seasons of year</h1> */}
            <strong id='a'>total profit : Rs. 10877</strong>
            <strong  id='b'>beneficiaries directly impacted : 12</strong>
            <strong  id='c'>beneficiaries indirectly impacted : 174</strong>
            <strong  id='d'>revenue generated : Rs. 15074</strong>
          </div>
            
        </div>
        </div>
    )
}

export default CircleImpact
